import React, { Component } from 'react';
import theme from '../../app.theme';
import renderHTML from 'react-render-html';
import Card from '@material-ui/core/Card'

class CardComponent extends Component {
  renderHeadline() {
    return (
      <div style={styles.headlineBox}>
        <h2 style={styles.headlineText}>{renderHTML(this.props.title)}</h2>
      </div>
    );
  }
  render() {
    const height = 'calc(100vh - 280px)';

    const card = {
      maxHeight: this.props.showAll ? undefined : height,
      minHeight: height,
      minWidth: '300px',
      overflowX: 'hidden',
      overflowY: 'auto',
      boxShadow: 'none',
    };


    return (
      <Card style={card}>
        {this.renderHeadline()}
        <div style={styles.content}>
          {this.props.children}
        </div>
      </Card>
    );
  }
}

const styles = {
  content: {
    padding: 20,
  },
  headlineBox: {
    padding: 10,
    paddingLeft: 20,
    borderBottomColor: '#ddd',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',

  },
  headlineText: {
    color: '#222',
    fontWeight: '100',
  },
};

export default CardComponent;



// WEBPACK FOOTER //
// ./src/app/components/card/card.js